import { render, staticRenderFns } from "./educationDetailsEdit.vue?vue&type=template&id=6bb31cdf&scoped=true&"
import script from "./educationDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./educationDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb31cdf",
  null
  
)

export default component.exports